import type { FunctionComponent } from 'react'
import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type { SubVerticalCrTopicPageQuery } from '../../../../generated/frontend'
import { Link } from '../../../../shared/components/Link'
import styles from './CRCategories.module.scss'

export const CRCategories: FunctionComponent<Props> = ({ categories }) => {
  // TODO: check if we need this check as part of https://whichonline.atlassian.net/browse/WAB-16
  if (!Array.isArray(categories) || categories.length === 0) {
    return null
  }

  return (
    <ol data-testid="cr-categories" className={classnames(styles.listBase, styles.list)}>
      {categories.map(({ articleLinks, description, link, title, id }) => {
        return (
          <li className={styles.block} key={id}>
            <Typography
              className={styles.title}
              data-testid="cr-topic-heading"
              id={`super-category-${id}`}
              tag="h2"
              textStyle="sb-text-heading-large"
            >
              {title}
            </Typography>
            <p>{description}</p>
            <ul className={classnames(styles.listBase, styles.linkList)}>
              {articleLinks.map(({ text, href }, index) => {
                return (
                  <li key={index}>
                    <Link href={href} className="sb-padding-bottom-3" type="NavigationLink">
                      {text}
                    </Link>
                  </li>
                )
              })}
            </ul>

            <Link href={link?.href} className={styles.viewAll}>
              {link?.text}
            </Link>
          </li>
        )
      })}
    </ol>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  categories: SubVerticalCrTopicPageQuery['subVerticalPage']['crCategories']['sections']
}
